import { CLEAR_LUX_PLUS_PENDING_RENEWAL_POINTS, SET_LUX_PLUS_PENDING_RENEWAL_POINTS } from 'actions/actionConstants'
import { setPayLuxPlusRenewalWithPoints } from 'actions/CheckoutActions'
import { updateMemberSubscription } from 'actions/LuxPlusActions'
import type { DefinedAppAction } from 'actions/types/ActionTypes'
import { isLuxPlusSubscriptionInCart } from 'checkout/selectors/view/luxPlusSubscriptionItems'
import getCanPayLuxPlusRenewalWithPoints from 'luxPlus/selectors/getCanPayLuxPlusRenewalWithPoints'
import type { ThunkAction } from 'redux-thunk'
import { reportClientError } from 'services/errorReportingService'

export function stageLuxPlusRenewalPointsAfterPurchase(order: App.Order): ThunkAction<void, App.State, undefined, DefinedAppAction> {
  return (dispatch, getState) => {
    const state = getState()
    const preference = state.checkout.payment.payLuxPlusRenewalWithPoints
    const memberId = state.auth.account.memberId
    const subscription = state.auth.account.luxPlus.member.subscription.item
    const membershipPurchase = isLuxPlusSubscriptionInCart(state) || order.subscriptionItems.length > 0
    const eligible = getCanPayLuxPlusRenewalWithPoints(state)

    if (preference === undefined) return
    dispatch(setPayLuxPlusRenewalWithPoints(undefined))
    if (!memberId || !eligible) return
    if (!membershipPurchase && subscription?.renewalStatus !== 'ALLOW_RENEWAL') return
    if (!membershipPurchase && preference === (subscription?.payRenewalWithPoints ?? false)) return

    dispatch({
      type: SET_LUX_PLUS_PENDING_RENEWAL_POINTS,
      pending: { orderId: order.id, memberId, payRenewalWithPoints: preference, membershipPurchase },
    })
  }
}

export function clearPendingLuxPlusRenewalPoints(orderId: string): DefinedAppAction {
  return { type: CLEAR_LUX_PLUS_PENDING_RENEWAL_POINTS, orderId }
}

export function failPendingLuxPlusRenewalPoints(orderId: string, error: unknown): ThunkAction<boolean, App.State, undefined, DefinedAppAction> {
  return (dispatch, getState) => {
    const state = getState()
    const pending = state.auth.account.luxPlus.member.pendingRenewalPoints
    if (pending?.orderId !== orderId || pending.memberId !== state.auth.account.memberId) return false

    dispatch(clearPendingLuxPlusRenewalPoints(orderId))
    reportClientError(error, { orderId, context: 'lux_plus_renewal_points_setup_failed' })
    return true
  }
}

export function savePendingLuxPlusRenewalPoints(orderId: string): ThunkAction<Promise<boolean | undefined>, App.State, undefined, DefinedAppAction> {
  return async(dispatch, getState) => {
    const state = getState()
    const pending = state.auth.account.luxPlus.member.pendingRenewalPoints
    if (pending?.orderId !== orderId) return

    dispatch(clearPendingLuxPlusRenewalPoints(orderId))
    if (pending.memberId !== state.auth.account.memberId) return

    try {
      await dispatch(updateMemberSubscription({ payRenewalWithPoints: pending.payRenewalWithPoints }))
      return true
    } catch(error) {
      reportClientError(error, { orderId, context: 'lux_plus_renewal_points_setup_failed' })
      return false
    }
  }
}
